import Vue from 'vue'
import '@progress/kendo-ui/js/cultures/kendo.culture.pt-BR'

export default {
  computed: {
    urlDataSourceUsuario () {
      return `${this.$url}/relatorio/usuarios`
    }
  },
  data () {
    return {
      columnsUsuario: [{
        field: 'posicao',
        title: ' ',
        width: 50,
        attributes: {
          class: 'text-center'
        }
      }, {
        field: 'nome',
        title: 'Usuário',
        template: this.itemTemplateUsuario
      }, {
        field: 'v1',
        title: 'Valor',
        format: 'R$ {0:n}',
        footerTemplate: '<div class="text-right">R$ #: kendo.toString(sum, "n") #</div>',
        attributes: {
          class: 'text-right'
        }
      }, {
        field: 'quant',
        title: 'Quant',
        footerTemplate: '<div class="text-center">#: kendo.toString(sum, "n0") #</div>',
        attributes: {
          class: 'text-center'
        }
      }],
      gridUsuario: [{
        detailInit: this.usuarioGrafico,
        resizable: true,
        height: 500
      }]
    }
  },
  methods: {
    itemTemplateUsuario (e) {
      var vm = this
      return {
        template: Vue.component('temp', {
          template: `
            <a :href='url(templateArgs.usuario_id)'
              style='color: #337ab7;' @click.prevent="buttonClick(templateArgs.usuario_id)">
              {{ templateArgs.nome }}
            </a>
           `,
          data () {
            return {
              templateArgs: {}
            }
          },
          methods: {
            url () {
              return `/sistema/vendas`
            },
            buttonClick () {
              let filtro = JSON.parse(JSON.stringify(vm.filtro))
              filtro.usuario = this.templateArgs.usuario_id
              localStorage.setItem('_filtroVendas', JSON.stringify(filtro))
              vm.$router.push('/sistema/vendas')
            }
          }
        }),
        templateArgs: e
      }
    }
  }
}
